var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal_content" }, [
      _c("div", { staticClass: "modal_header" }, [
        _c("h5", [_vm._v("\n        De-register Machine\n      ")]),
        _vm._v(" "),
        _c("button", {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal_body" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form_wrap" }, [
          _c("div", { staticClass: "fx_form_wrap detail_style" }, [
            _c("div", { staticClass: "form_row" }, [
              _c("div", { staticClass: "form_item inline_type" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "fx_form" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.oneTimeKey,
                        expression: "oneTimeKey"
                      }
                    ],
                    ref: "oneTimeKey",
                    attrs: {
                      type: "text",
                      placeholder: "Enter One Time Key Code *"
                    },
                    domProps: { value: _vm.oneTimeKey },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.oneTimeKey = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "authorization",
                          rawName: "v-authorization",
                          value: "EXECUTE",
                          expression: "'EXECUTE'"
                        }
                      ],
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.onClickSendOneTimeKey }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("Re-Generate Key")) +
                          "\n                "
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal_footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("sdl.common.label.close")) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            directives: [
              {
                name: "authorization",
                rawName: "v-authorization",
                value: "UPDATE",
                expression: "'UPDATE'"
              }
            ],
            staticClass: "btn btn-primary",
            class: { "btn-disabled": _vm.isKeyEmpty },
            attrs: {
              type: "button",
              "data-dismiss": "modal",
              disabled: _vm.isKeyEmpty
            },
            on: { click: _vm.onClickDeregisterMachine }
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("De-register Machine")) + "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "comment_wrap" }, [
      _c("p", [
        _vm._v(
          "After de-registering you won't be able to use web client on this machine."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "ctitle" }, [
      _vm._v("One Time Key"),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37f807dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37f807dd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/web-client/popup/DeRegisterMachinePopup.vue
// module id = null
// module chunks = 